var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedItemIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_18098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32.0014C64 25.3196 57.3535 19.5019 47.5333 16.4694C44.5008 6.64646 38.6804 0 32.0014 0C25.3223 0 19.5019 6.64646 16.4694 16.4667C6.64646 19.5019 0 25.3196 0 32.0014C0 38.6831 6.64646 44.5008 16.4667 47.5333C19.4992 57.3563 25.3169 64 31.9986 64C38.6804 64 44.4981 57.3535 47.5306 47.5333C57.3535 44.5008 63.9973 38.6831 63.9973 32.0014H64Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_18098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedItemIcon1);
export default __webpack_public_path__ + "static/media/recommendedItemIcon1.ff3bdef4de6ca4d36b3c59f0032f964b.svg";
export { ForwardRef as ReactComponent };